import React from 'react'

const policy = ()=>{
    return(
        <div>
            <h2>Политика на користење</h2>
            <p>14 Август 2020</p>
            <hr/>
            <ul>
                <p>Сите локации на места(вело-паркинзи, сервиси, продавници) се сопственост на мкТочак и се наменети за користење само на <a href='/'>mktocak.web.app</a>. Забрането е користење на истите за комерциални цели без одобение од мкТочак</p>
                <p>Забрането е објавување неточни информации</p>
                <p>Забрането е користење на овој сајт за илегални активности</p>
                <p>мкТочак го задржува правото во секое време да го суспендира вашиот профил</p>
            </ul>
        </div>
    )
}

export default policy;